/* DocMayaKeys — site key management for the DocMaya embed script. */
import React, { useState } from "react";
import { P, FC } from "../../shared/constants";
import DataTable from "../components/DataTable";
import EmptyState from "../components/EmptyState";
import ErrorState from "../components/ErrorState";
import Skeleton from "../components/Skeleton";
import Chip from "../components/Chip";
import Modal from "../components/Modal";
import { Refresh, Plus, Key, Copy, Trash } from "../icons";
var E = React.createElement;

function maskKey(k){
  if(!k) return "—";
  var s = String(k);
  if(s.length <= 8) return s;
  return s.slice(0,4) + "…" + s.slice(-4);
}

export default function DocMayaKeys(props){
  var keys    = props.keys || [];
  var loading = !!props.loading;
  var error   = props.error || null;

  var st = useState({ open:false, domain:"" });
  var s = st[0], setS = st[1];

  function copy(text, label){
    if(typeof navigator==="undefined"||!navigator.clipboard) return;
    navigator.clipboard.writeText(text).then(function(){ props.showToast && props.showToast(label+" copied"); });
  }

  function submitGenerate(){
    var d = (s.domain||"").trim();
    if(!d){ props.showToast && props.showToast("Enter a licensed domain","error"); return; }
    props.onGenerate && props.onGenerate(d);
    setS({ open:false, domain:"" });
  }

  var columns = [
    { key:"domain", label:"Domain", render:function(k){
        return E("div",null,
          E("div",{style:{fontWeight:700}}, k.domain),
          E("div",{style:{fontSize:11,color:P.slateM,fontFamily:FC}},
            "Created "+(k.createdAt||"").split("T")[0]));
      } },
    { key:"siteKey", label:"Site key", mono:true, render:function(k){
        var full = k.siteKey || k.id;
        return E("span",{style:{display:"inline-flex",alignItems:"center",gap:4}},
          E("span",{title:full}, maskKey(full)),
          E("button",{type:"button","aria-label":"Copy site key for "+k.domain,
            onClick:function(e){e.stopPropagation();copy(full,"Site key")},
            style:{background:"transparent",border:"none",cursor:"pointer",
              padding:4,color:P.slateM,borderRadius:4,minWidth:28,minHeight:28,
              display:"inline-flex",alignItems:"center"}},
            E(Copy,{size:13})));
      } },
    { key:"status", label:"Status", render:function(k){
        return E(Chip,{
          variant:k.status==="revoked"?"coral":"emerald", size:"sm"
        }, k.status||"active");
      } },
    { key:"actions", label:"", align:"right", render:function(k){
        return k.status==="revoked"
          ? E(Chip,{variant:"slate",size:"sm"},"Revoked")
          : E("button",{type:"button","aria-label":"Revoke site key for "+k.domain,
              onClick:function(e){e.stopPropagation();props.onRevoke&&props.onRevoke(k)},
              style:{padding:"6px 10px",borderRadius:6,border:"none",
                background:P.coralLt,color:P.coralDk||P.coral,fontSize:11,fontWeight:700,
                cursor:"pointer",minHeight:32,display:"inline-flex",alignItems:"center",gap:4}},
              E(Trash,{size:12}), "Revoke");
      } }
  ];

  var toolbar = E("div",{style:{display:"flex",justifyContent:"flex-end",gap:8,marginBottom:14}},
    E("button",{type:"button",onClick:props.onRefresh,
      style:{padding:"8px 12px",borderRadius:8,border:"1px solid "+P.bdr,
        background:P.card,fontSize:11,fontWeight:600,cursor:"pointer",minHeight:36,
        display:"inline-flex",alignItems:"center",gap:6}},
      E(Refresh,{size:13}),"Refresh"),
    E("button",{type:"button",onClick:function(){setS({open:true,domain:""})},
      style:{padding:"8px 12px",borderRadius:8,border:"none",
        background:P.pri,color:"#fff",fontSize:11,fontWeight:700,cursor:"pointer",minHeight:36,
        display:"inline-flex",alignItems:"center",gap:6}},
      E(Plus,{size:13}),"Generate key"));

  var body;
  if(loading)    body = E(Skeleton,{rows:5,height:24,label:"Loading DocMaya keys…"});
  else if(error) body = E(ErrorState,{title:"We couldn't load DocMaya keys.",
                          message:error, onRetry:props.onRefresh});
  else if(keys.length===0)
                 body = E(EmptyState,{icon:E(Key,{size:32}),
                          title:"No DocMaya keys yet.",
                          message:"Generate a site key for a licensed domain to enable the DocMaya embed script.",
                          action:E("button",{type:"button",onClick:function(){setS({open:true,domain:""})},
                            style:{padding:"8px 14px",borderRadius:8,border:"none",
                              background:P.pri,color:"#fff",fontSize:11,fontWeight:700,
                              cursor:"pointer",minHeight:36,display:"inline-flex",alignItems:"center",gap:6}},
                            E(Plus,{size:13}),"Generate key")});
  else           body = E(DataTable,{columns:columns,rows:keys,
                          rowKey:function(k){return k.id||k.siteKey}});

  /* Generate-key modal — simple controlled domain input. */
  var modal = E(Modal,{
    open:s.open, onClose:function(){setS({open:false,domain:""})},
    title:"Generate DocMaya site key", size:"sm",
    footer:[
      E("button",{key:"cancel",type:"button",onClick:function(){setS({open:false,domain:""})},
        style:{padding:"8px 14px",borderRadius:8,border:"1px solid "+P.bdr,background:P.card,
          fontSize:11,fontWeight:600,cursor:"pointer",minHeight:36}},"Cancel"),
      E("button",{key:"go",type:"button",onClick:submitGenerate,
        style:{padding:"8px 14px",borderRadius:8,border:"none",background:P.pri,color:"#fff",
          fontSize:11,fontWeight:700,cursor:"pointer",minHeight:36}},"Generate")
    ]
  },
    E("label",{style:{display:"block",fontSize:11,fontWeight:700,color:P.slateM,marginBottom:6}}, "Licensed domain"),
    E("input",{type:"text",value:s.domain,
      onChange:function(e){setS(Object.assign({},s,{domain:e.target.value}))},
      placeholder:"saccounty.gov", autoFocus:true,
      style:{width:"100%",padding:"10px 12px",borderRadius:8,border:"1px solid "+P.bdr,
        fontSize:13,fontFamily:FC,minHeight:40}}),
    E("p",{style:{fontSize:11,color:P.slateM,marginTop:8}},
      "The domain must already have an active license.")
  );

  return E("div",null, toolbar, body, modal);
}
